import { render, staticRenderFns } from "./sport_competition_created.vue?vue&type=template&id=589d5cd5&scoped=true&"
import script from "./sport_competition_created.vue?vue&type=script&lang=js&"
export * from "./sport_competition_created.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589d5cd5",
  null
  
)

export default component.exports